import { authApi } from '@/api/auth.api';
import i18n from '@/i18n';
import { openAuth } from '@/pages/Auth';
import { store } from '@/store';

import { type TServiceId, getServiceConfig } from '../config';
import { type IBridgeHostDeps } from './create-system-handlers';

/**
 * Дефолтные зависимости хоста для сервиса: связывают мост с авторизацией оболочки.
 *
 * Ключевое — ленивая авторизация в `sso.authorize` (как нативный AuthCoordinator):
 * если суперапп-сессии нет, открываем оверлей (`openAuth`) и ждём результат; при успехе
 * запрашиваем одноразовый SSO-код для бэкенда сервиса. Состояние сессии читаем из стора
 * на момент вызова (не на момент сборки deps).
 */
export function createDefaultHostDeps(serviceId: TServiceId): IBridgeHostDeps {
  const { clientId } = getServiceConfig(serviceId);

  return {
    auth: {
      getStatus: () =>
        store.getState().auth.isAuthorized ? 'authenticated' : 'unauthenticated'
    },
    sso: {
      authorize: async () => {
        if (!store.getState().auth.isAuthorized) {
          const ok = await openAuth('login');
          if (!ok) throw new Error(i18n.t('errors.authCancelled'));
        }
        return authApi.ssoAuthorize(clientId);
      }
    }
  };
}
